import { ElementRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  constructor() { }

  public selectedAction: string | null = null;
  
  private bodyWidth: number = 0;
  private bodyHeight: number = 0;
  public videoElement!: ElementRef;

  public getBodyWidth(): string {
    this.bodyWidth = window.innerWidth;
    return `${this.bodyWidth}px`;
  }

  public getBodyWidthWithHeader(): string {
    this.bodyWidth = window.innerWidth;
    return `${this.bodyWidth - 60}px`;
  }

    public getBodyWidthWithContent(): string {
    this.bodyWidth = window.innerWidth;
    return `${this.bodyWidth - 360}px`;
  }

  public getBodyHeight(): string {
    this.bodyHeight = window.innerHeight;
    return `${this.bodyHeight}px`;
  }

  public getBodyHeightWithHeader(): string {
    this.bodyHeight = window.innerHeight;
    return `${this.bodyHeight - 64}px`;
  }

  public getBodyHeightNumber(): number {
    this.bodyHeight = window.innerHeight;
    return this.bodyHeight;
  }

    // 비디오 위에 자막 위치 선정을 위한 함수
    public getVideoPosition() {
      if (this.videoElement) {
        return this.videoElement.nativeElement.getBoundingClientRect();
      }
      return null;
    }

}
